<!--
 * @Description:
 * @Date: 2020-07-25 14:38:21
 * @LastEditTime: 2020-07-25 14:38:21
 * @LastEditors: kangxiaoyu
 -->
<template>
  <div class="table_btn_ops_fixed">
    <el-popover
      placement="left"
      trigger="hover"
      :visible-arrow="false"
      popper-class="table_btn_ops_fixed_popper_btn"
    >
      <!-- isEmpty 接受传值 传noEmpty 无操作 传空 有操作 -->
      <div v-show="isEmpty" class="table_btn_fixed_btn_listNew">
        <div class="table_btn_fixed_box">
          <slot name="tableFixedBtnList"/>
        </div>
      </div>
      <div slot="reference" class="table_btn_ops_fixed_img">
        <img v-if="isEmpty" :src="imgSrcByData" @mouseover="handeleImg" @mouseleave="handeleOP">
        <el-tooltip v-else content="暂无可操作项" placement="top" effect="light">
          <img :src="imgSrcByDatabanned" alt>
        </el-tooltip>
      </div>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'table-fixed-right-template',
  props: {
    // isEmpty: {
    //   type: String
    // }
  },
  data() {
    return {
      imgSrcByData: require('@/assets/img/noChecked.png'),
      imgSrcByDatabanned: require('@/assets/img/bannedChecked.png'),
      isEmpty: true
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.updataMethod()
  },
  updated() {
    this.updataMethod()
  },
  destroyed() {
    // console.log('destroyed');
    this.isEmpty = true
  },
  methods: {
    handeleImg() {
      this.imgSrcByData = require('@/assets/img/isChecked.png')
    },
    handeleOP() {
      this.imgSrcByData = require('@/assets/img/noChecked.png')
    },
    updataMethod() {
      if (this.$slots.tableFixedBtnList) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
    }
  }
}
</script>
<style lang="scss">
.table_btn_ops_fixed_popper_btn {
  padding: 0 !important;
  min-width: unset!important;
}
.table_btn_ops_fixed_img{
  cursor: pointer;
  img{
    width: 30px;
    height: 30px;
  }
}
</style>
